import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/services/api-client';

export type StripeMode = 'test' | 'live' | 'missing' | 'unknown';

export function useStripeMode() {
    return useQuery({
        queryKey: ['admin', 'stripe-mode'],
        queryFn: async () => {
            const { data, error } = await apiClient.get<{ mode?: string }>('/store/admin/stripe-mode');
            if (error) throw new Error(error.message);
            const mode = data?.mode;
            if (mode === 'test' || mode === 'live' || mode === 'missing' || mode === 'unknown') return mode;
            return 'unknown' as const;
        },
        staleTime: 60_000,
    });
}
